<ng-container *ngIf="isInfoActive">
    <button mat-icon-button (click)="showQuill($event)" class ="flex items-center">
        <mat-icon class="icon-size-6" svgIcon="heroicons_solid:information-circle"></mat-icon>
    </button>
 </ng-container> 
